import React from "react";
import Project from "./projetEtp";

export function ProjectDeferred() {
  return <Project status="Reporté" />;
}